import { render, staticRenderFns } from "./StockForm.vue?vue&type=template&id=d87d72c8&scoped=true&"
import script from "./StockForm.vue?vue&type=script&lang=ts&"
export * from "./StockForm.vue?vue&type=script&lang=ts&"
import style0 from "./StockForm.vue?vue&type=style&index=0&id=d87d72c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87d72c8",
  null
  
)

export default component.exports